export default __webpack_public_path__ + "static/media/logo.808ceef8.png";